module.exports = __webpack_public_path__ + "static/affiliates-preview-0473b77529f19e3ef4e4844f77a63193.png";